@app.directive 'fullCarousel', (matrixItemService, mobileDetectionService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @isMobile = mobileDetectionService.isMobile
    @headerLimit = if @isMobile then 30 else 50
    @charLimit = if @isMobile then 50 else 100
    @emptyImage = _.isEmpty(@image)

    this
  controllerAs: 'fullCarousel'
  templateUrl: "/assets/templates/components/carousel/fullCarousel/fullCarousel.html"
  bindToController: {
    title: '='
    image: '='
    url: '='
    description: '='
    alt: '='
    hasVideo: '='
  }
